import { NeoModel, Rules, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class EmailAddress extends ValueObject {

    @Rules.EmailAddress()
    emailAddress: string;

    constructor(emailAddress: string = "") {
        super();
        this.emailAddress = emailAddress;
    }
 }